export const video = () => {

	let els = document.querySelectorAll('[data-function="video"]')

	if (!els.length) return

	els.forEach(el => {

		let button = el.querySelector('[data-el="button"]'),
			wrapper = el.querySelector('[data-el="video-wrapper"]')

		button.addEventListener('click', () => {

			let src = wrapper.getAttribute('data-embed-src');

			if (!src) return;

			if (src.indexOf('?') === -1) {
				src += '?autoplay=1&rel=0&modestbranding=1';
			} else {
				src += '&autoplay=1&rel=0&modestbranding=1';
			}

			let iframe = document.createElement('iframe');

			iframe.src = src;
			iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
			iframe.setAttribute('allowfullscreen', '');

			wrapper.innerHTML = '';
			wrapper.appendChild(iframe);

		})
	})
}

export default () => { }